import _slicedToArray from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { APPS } from './meta';

/**
 * `instance` tests for a string of characters, possibly with
 * single dashes interspersed. Double dashes are not allowed.
 * Neither are dashes at the beginning or end.
 */
var instance = '[a-z0-9]+(?:-[a-z0-9]+)*';
var app = APPS.join('|');
var features = 'lit';
/**
 * `api` tests for a string of characters, possibly with single
 * or double dashes interspersed. Dashes at the beginning or end
 * are not allowed.
 */

var api = '[a-z0-9]+(?:--?[a-z0-9]+)*';
var subSubdomainRegex = "^(?:(".concat(instance, ")--)?(").concat(app, ")(?:--(").concat(features, "))?(?:--(").concat(api, "))?$");
/**
 * **NOTE: This is an internal method. Do not use it outside @peloton/urls**
 *
 * Converts a sub-subdomain into its parts according to our conventions
 * for UAT domains.
 *
 * @param subSubdomain A sub-subdomain for a UAT website, or `undefined`
 */

export var toSubSubdomainComponents = function toSubSubdomainComponents(subSubdomain) {
  var match = subSubdomain === null || subSubdomain === void 0 ? void 0 : subSubdomain.match(subSubdomainRegex);

  if (!match) {
    return undefined;
  }

  var _match = _slicedToArray(match, 5),
      instance = _match[1],
      app = _match[2],
      features = _match[3],
      api = _match[4];

  return {
    instance: instance,
    app: app,
    features: features,
    api: api
  };
};